import { Verifiable } from './verifiable';

export class Phone extends Verifiable {
    
    constructor(
        public phone: string = '',
        public whatsapp: boolean = false, 
        verified: boolean = false) {
        super(verified);
    }

}